import roles from '@/utils/roles'

let tabs = [
    {
        name: 'Identification',

        options: {
            exact: true,
            props: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry],
            },
        },

        parent: {
            path: 'identification',
            name: 'manage-executive-identification',
            component: () => import('@/pages/manage/identification/index'),
            roles: [roles.admin, roles.inHouseDataEntry],
            props: route => ({ executiveId: parseInt(route.params.executiveId) }),
        },
    },
    {
        name: 'Compensation',

        options: {
            exact: true,
            props: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry],
            },
        },

        parent: {
            path: 'compensation',
            name: 'manage-executive-copmensation',
            component: () => import('@/pages/manage/executive/compensation/ManageExecutiveCompensationTab.vue'),
            props: route => ({ executiveId: parseInt(route.params.executiveId) }),
        },
    },
    {
        name: 'Education',

        options: {
            exact: true,
            props: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry],
            },
        },

        parent: {
            path: 'education',
            name: 'manage-executive-education',
            component: () => import('@/pages/manage/Education/List'),
            props: route => ({ executiveId: parseInt(route.params.executiveId) }),
        },

        children: [
            {
                path: 'add',
                name: 'manage-executive-education-add',
                component: () => import('@/pages/manage/Education/Add'),
                props: route => ({
                    executiveId: parseInt(route.params.executiveId),
                }),
            },
            {
                path: ':educationId',
                name: 'manage-executive-education-edit',
                component: () => import('@/pages/manage/Education/Edit'),
                props: route => ({
                    executiveId: parseInt(route.params.executiveId),
                    educationId: parseInt(route.params.educationId),
                }),
            },
        ],
    },
    {
        name: 'Jobs',

        options: {
            exact: true,
            props: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry, roles.dataEntryJobHistory],
            },
        },

        parent: {
            path: 'jobs',
            name: 'manage-executive-jobs',
            component: () => import('@/pages/manage/Jobs/List'),
            props: route => ({ executiveId: parseInt(route.params.executiveId) }),
        },
        children: [
            {
                path: 'add',
                name: 'manage-executive-jobs-add',
                component: () => import('@/pages/manage/Jobs/Add'),
                props: route => ({
                    executiveId: parseInt(route.params.executiveId),
                }),
            },
            {
                path: ':companyId',
                name: 'manage-executive-jobs-edit',
                component: () => import('@/pages/manage/Jobs/Edit'),
                props: route => ({
                    executiveId: parseInt(route.params.executiveId),
                    companyId: parseInt(route.params.companyId),
                }),
            },
        ],
    },
    {
        name: 'Entity Providers',

        options: {
            exact: true,
            props: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry],
            },
        },

        parent: {
            path: 'providers',
            name: 'manage-executive-providers',
            component: () => import('@/pages/manage/entity-providers/list'),
            props: route => ({ entityType: 'executive', entityId: parseInt(route.params.executiveId) }),
        },

        children: [
            {
                path: 'new',
                display: 'Provider Executive',
                component: () => import('@/pages/manage/entity-providers/new-provider-executive-page'),
                props: route => ({ executiveId: parseInt(route.params.executiveId) }),
            },
            {
                path: 'compare',
                display: 'Provider Executive',
                component: () => import('@/pages/manage/provider-executive-compare-page'),
                props: route => ({ executiveId: parseInt(route.params.executiveId) }),
            },
        ],
    },
    {
        name: 'Social Media',

        options: {
            exact: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry, roles.matching, roles.dataEntry],
            },
        },

        parent: {
            path: 'social-media',
            name: 'manage-executive-social-media',
            component: () => import('@/pages/manage/social-media/list'),
            props: route => ({
                entityId: parseInt(route.params.executiveId),
                entityType: 'executive',
                addRoute: 'manage-executive-social-media-add',
                editRoute: 'manage-executive-social-media-edit',
            }),
        },

        children: [
            {
                path: 'add',
                name: 'manage-executive-social-media-add',
                component: () => import('@/pages/manage/social-media/add'),
                props: route => ({
                    entityId: parseInt(route.params.executiveId),
                    entityType: 'executive',
                    nextRoute: 'manage-executive-social-media',
                }),
            },
            {
                path: ':handleId/edit',
                name: 'manage-executive-social-media-edit',
                component: () => import('@/pages/manage/social-media/edit'),
                props: route => ({
                    entityId: parseInt(route.params.executiveId),
                    entityType: 'executive',
                    handleId: parseInt(route.params.handleId),
                    nextRoute: 'manage-executive-social-media',
                }),
            },
        ],
    },
    {
        name: 'Incentives',

        options: {
            exact: true,
            props: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry, roles.research, roles.salesAdmin],
            },
        },

        parent: {
            path: 'incentives',
            name: 'manage-executive-incentives',
            component: () => import('@/pages/manage/executive/ManageExecutiveIncentives.vue'),
            props: route => ({ executiveId: parseInt(route.params.executiveId) }),
        },
    },
    {
        name: 'Premium Research',

        options: {
            exact: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.research, roles.dataEntryInterviewSurveys],
            },
        },

        parent: {
            path: 'reports',
            name: 'manage-report',
            component: () => import('@/pages/manage/ceo-change/ReportList'),
            props: route => ({
                executiveId: parseInt(route.params.executiveId),
                addRoute: 'manage-report-add',
                editRoute: 'manage-report-edit',
            }),
        },

        children: [
            {
                path: 'add',
                name: 'manage-report-add',
                component: () => import('@/pages/manage/ceo-change/AddReport'),
                props: route => ({
                    executiveId: parseInt(route.params.executiveId),
                }),
            },
            {
                path: ':reportId/edit',
                name: 'manage-report-edit',
                component: () => import('@/pages/manage/ceo-change/EditReport'),
                props: route => ({
                    reportId: parseInt(route.params.reportId),
                    executiveId: parseInt(route.params.executiveId),
                }),
            },

            {
                path: ':reportId/interviews/add',
                name: 'manage-interview-add',
                component: () => import('@/pages/manage/ceo-change/Interviews/AddInterview'),
                props: route => ({
                    executiveId: parseInt(route.params.executiveId),
                    reportId: parseInt(route.params.reportId),
                }),
            },
            {
                path: ':reportId/interviews/:interviewId/edit',
                name: 'manage-interview-edit',
                component: () => import('@/pages/manage/ceo-change/Interviews/EditInterview'),
                props: route => ({
                    executiveId: parseInt(route.params.executiveId),
                    reportId: parseInt(route.params.reportId),
                    interviewId: parseInt(route.params.interviewId),
                }),
            },
        ],
    },
]

export default tabs
